export const createProtoV1ApiConfig = (protoService, options) => {
  const service = {
    ...(options == null ? void 0 : options.serviceOptions),
    baseUrl: ''
  };
  return Object.keys(protoService).reduce((acc, methodName) => {
    var _options$methodsOptio;
    return {
      ...acc,
      [methodName]: {
        ...(options == null ? void 0 : (_options$methodsOptio = options.methodsOptions) == null ? void 0 : _options$methodsOptio[methodName]),
        name: methodName,
        service,
        queryFn: async args => {
          const response = await protoService[methodName](args.request);
          return response;
        }
      }
    };
  }, {});
};
//# sourceMappingURL=createProtoV1ApiConfig.js.map